export let json = {
  "@type": "Question",
  "name": "Como adquirir o seguro viagem?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Compre em https://www.seguroviagem.srv.br/"
  }
}